
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {AccountingType} from './AccountingType';
import {FieldModelAccountingType} from './AccountingType';
import {TradingMode} from './TradingMode';
import {FieldModelTradingMode} from './TradingMode';
import {StopOutType} from './StopOutType';
import {FieldModelStopOutType} from './StopOutType';
import {SymbolGroupSettings} from './SymbolGroupSettings';
import {FieldModelSymbolGroupSettings} from './SymbolGroupSettings';

/**
 * AccountGroup struct
 */
class AccountGroup {
  /**
   * Initialize struct
   * @param {!UUID=} id
   * @param {!number=} sortOrder
   * @param {!UUID=} platformId
   * @param {!string=} name
   * @param {!string=} comment
   * @param {!string=} description
   * @param {!boolean=} isDemo
   * @param {!boolean=} isEnabled
   * @param {!boolean=} isOTPEnabled
   * @param {!boolean=} isTradeEnabled
   * @param {!AccountingType=} defaultAccountingType
   * @param {!UUID=} defaultBalanceCurrencyId
   * @param {!number=} defaultBalance
   * @param {!number=} defaultCredit
   * @param {!number=} defaultLeverage
   * @param {!number=} marginCallLevel
   * @param {!TradingMode=} marginCallAccessType
   * @param {!number=} stopOutLevel
   * @param {!StopOutType=} stopOutType
   * @param {!TradingMode=} stopOutAccessType
   * @param {!number=} defaultMaxPendingOrders
   * @param {!Map=} symbolGroupSettings
   * @param {!boolean=} isSwapEnabled
   * @param {!number=} minPasswordLength
   * @param {!boolean=} deprecated1
   * @param {!boolean=} deprecated2
   * @param {!boolean=} isSSLAccessEnabled
   * @param {!boolean=} isHTTPSAccessEnabled
   * @param {!boolean=} isWSSAccessEnabled
   * @param {!boolean=} isFIXAccessEnabled
   * @param {!number=} index
   * @param {number=} maxLeverage
   * @param {UUID=} leverageProfileId
   * @param {!number=} defaultMaxOrders
   * @param {number=} maxDepositOperationAmount
   * @param {!boolean=} botApiEnabled
   * @constructor
   */
  constructor (id = UUID.sequential(), sortOrder = 0, platformId = new UUID(), name = '', comment = '', description = '', isDemo = false, isEnabled = false, isOTPEnabled = false, isTradeEnabled = false, defaultAccountingType = new AccountingType(), defaultBalanceCurrencyId = new UUID(), defaultBalance = 0.0, defaultCredit = 0.0, defaultLeverage = 0, marginCallLevel = 0.0, marginCallAccessType = new TradingMode(), stopOutLevel = 0.0, stopOutType = new StopOutType(), stopOutAccessType = new TradingMode(), defaultMaxPendingOrders = new UInt64(0, 0), symbolGroupSettings = new Map(), isSwapEnabled = false, minPasswordLength = 0, deprecated1 = false, deprecated2 = false, isSSLAccessEnabled = true, isHTTPSAccessEnabled = true, isWSSAccessEnabled = true, isFIXAccessEnabled = true, index = 0, maxLeverage = null, leverageProfileId = null, defaultMaxOrders = new UInt64(2000, 0), maxDepositOperationAmount = null, botApiEnabled = true) {
    this.id = id
    this.SortOrder = sortOrder
    this.PlatformId = platformId
    this.Name = name
    this.Comment = comment
    this.Description = description
    this.IsDemo = isDemo
    this.IsEnabled = isEnabled
    this.IsOTPEnabled = isOTPEnabled
    this.IsTradeEnabled = isTradeEnabled
    this.DefaultAccountingType = defaultAccountingType
    this.DefaultBalanceCurrencyId = defaultBalanceCurrencyId
    this.DefaultBalance = defaultBalance
    this.DefaultCredit = defaultCredit
    this.DefaultLeverage = defaultLeverage
    this.MarginCallLevel = marginCallLevel
    this.MarginCallAccessType = marginCallAccessType
    this.StopOutLevel = stopOutLevel
    this.StopOutType = stopOutType
    this.StopOutAccessType = stopOutAccessType
    this.DefaultMaxPendingOrders = defaultMaxPendingOrders
    this.SymbolGroupSettings = symbolGroupSettings
    this.IsSwapEnabled = isSwapEnabled
    this.MinPasswordLength = minPasswordLength
    this.Deprecated1 = deprecated1
    this.Deprecated2 = deprecated2
    this.IsSSLAccessEnabled = isSSLAccessEnabled
    this.IsHTTPSAccessEnabled = isHTTPSAccessEnabled
    this.IsWSSAccessEnabled = isWSSAccessEnabled
    this.IsFIXAccessEnabled = isFIXAccessEnabled
    this.Index = index
    this.MaxLeverage = maxLeverage
    this.LeverageProfileId = leverageProfileId
    this.DefaultMaxOrders = defaultMaxOrders
    this.MaxDepositOperationAmount = maxDepositOperationAmount
    this.BotApiEnabled = botApiEnabled
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountGroup}
   * @param {!AccountGroup} other Other struct
   * @returns {!AccountGroup} This struct
   */
  copy (other) {
    if (other.id != null) {
      this.id = new UUID(other.id)
    } else {
      this.id = null
    }
    if (other.SortOrder != null) {
      this.SortOrder = other.SortOrder
    } else {
      this.SortOrder = null
    }
    if (other.PlatformId != null) {
      this.PlatformId = new UUID(other.PlatformId)
    } else {
      this.PlatformId = null
    }
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Comment != null) {
      this.Comment = other.Comment
    } else {
      this.Comment = null
    }
    if (other.Description != null) {
      this.Description = other.Description
    } else {
      this.Description = null
    }
    if (other.IsDemo != null) {
      this.IsDemo = other.IsDemo
    } else {
      this.IsDemo = null
    }
    if (other.IsEnabled != null) {
      this.IsEnabled = other.IsEnabled
    } else {
      this.IsEnabled = null
    }
    if (other.IsOTPEnabled != null) {
      this.IsOTPEnabled = other.IsOTPEnabled
    } else {
      this.IsOTPEnabled = null
    }
    if (other.IsTradeEnabled != null) {
      this.IsTradeEnabled = other.IsTradeEnabled
    } else {
      this.IsTradeEnabled = null
    }
    if (other.DefaultAccountingType != null) {
      this.DefaultAccountingType = AccountingType.fromObject(other.DefaultAccountingType)
    } else {
      this.DefaultAccountingType = null
    }
    if (other.DefaultBalanceCurrencyId != null) {
      this.DefaultBalanceCurrencyId = new UUID(other.DefaultBalanceCurrencyId)
    } else {
      this.DefaultBalanceCurrencyId = null
    }
    if (other.DefaultBalance != null) {
      this.DefaultBalance = other.DefaultBalance
    } else {
      this.DefaultBalance = null
    }
    if (other.DefaultCredit != null) {
      this.DefaultCredit = other.DefaultCredit
    } else {
      this.DefaultCredit = null
    }
    if (other.DefaultLeverage != null) {
      this.DefaultLeverage = other.DefaultLeverage
    } else {
      this.DefaultLeverage = null
    }
    if (other.MarginCallLevel != null) {
      this.MarginCallLevel = other.MarginCallLevel
    } else {
      this.MarginCallLevel = null
    }
    if (other.MarginCallAccessType != null) {
      this.MarginCallAccessType = TradingMode.fromObject(other.MarginCallAccessType)
    } else {
      this.MarginCallAccessType = null
    }
    if (other.StopOutLevel != null) {
      this.StopOutLevel = other.StopOutLevel
    } else {
      this.StopOutLevel = null
    }
    if (other.StopOutType != null) {
      this.StopOutType = StopOutType.fromObject(other.StopOutType)
    } else {
      this.StopOutType = null
    }
    if (other.StopOutAccessType != null) {
      this.StopOutAccessType = TradingMode.fromObject(other.StopOutAccessType)
    } else {
      this.StopOutAccessType = null
    }
    if (other.DefaultMaxPendingOrders != null) {
      this.DefaultMaxPendingOrders = UInt64.fromNumber(other.DefaultMaxPendingOrders)
    } else {
      this.DefaultMaxPendingOrders = null
    }
    if (other.SymbolGroupSettings != null) {
      this.SymbolGroupSettings = new Map()
      Object.keys(other.SymbolGroupSettings).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.SymbolGroupSettings[key] != null) {
            let tempValue
            tempValue = SymbolGroupSettings.fromObject(other.SymbolGroupSettings[key])
            this.SymbolGroupSettings.set(tempKey, tempValue)
          } else {
            this.SymbolGroupSettings.set(tempKey, null)
          }
        }
      })
    } else {
      this.SymbolGroupSettings = null
    }
    if (other.IsSwapEnabled != null) {
      this.IsSwapEnabled = other.IsSwapEnabled
    } else {
      this.IsSwapEnabled = null
    }
    if (other.MinPasswordLength != null) {
      this.MinPasswordLength = other.MinPasswordLength
    } else {
      this.MinPasswordLength = null
    }
    if (other.Deprecated1 != null) {
      this.Deprecated1 = other.Deprecated1
    } else {
      this.Deprecated1 = null
    }
    if (other.Deprecated2 != null) {
      this.Deprecated2 = other.Deprecated2
    } else {
      this.Deprecated2 = null
    }
    if (other.IsSSLAccessEnabled != null) {
      this.IsSSLAccessEnabled = other.IsSSLAccessEnabled
    } else {
      this.IsSSLAccessEnabled = null
    }
    if (other.IsHTTPSAccessEnabled != null) {
      this.IsHTTPSAccessEnabled = other.IsHTTPSAccessEnabled
    } else {
      this.IsHTTPSAccessEnabled = null
    }
    if (other.IsWSSAccessEnabled != null) {
      this.IsWSSAccessEnabled = other.IsWSSAccessEnabled
    } else {
      this.IsWSSAccessEnabled = null
    }
    if (other.IsFIXAccessEnabled != null) {
      this.IsFIXAccessEnabled = other.IsFIXAccessEnabled
    } else {
      this.IsFIXAccessEnabled = null
    }
    if (other.Index != null) {
      this.Index = other.Index
    } else {
      this.Index = null
    }
    if (other.MaxLeverage != null) {
      this.MaxLeverage = other.MaxLeverage
    } else {
      this.MaxLeverage = null
    }
    if (other.LeverageProfileId != null) {
      this.LeverageProfileId = new UUID(other.LeverageProfileId)
    } else {
      this.LeverageProfileId = null
    }
    if (other.DefaultMaxOrders != null) {
      this.DefaultMaxOrders = UInt64.fromNumber(other.DefaultMaxOrders)
    } else {
      this.DefaultMaxOrders = null
    }
    if (other.MaxDepositOperationAmount != null) {
      this.MaxDepositOperationAmount = other.MaxDepositOperationAmount
    } else {
      this.MaxDepositOperationAmount = null
    }
    if (other.BotApiEnabled != null) {
      this.BotApiEnabled = other.BotApiEnabled
    } else {
      this.BotApiEnabled = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountGroup}
   * @returns {!AccountGroup} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountGroupModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountGroupModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountGroup}
   * @param {!AccountGroup} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountGroup)) {
      throw new TypeError('Instance of AccountGroup is required!')
    }
    // noinspection RedundantIfStatementJS
    if (this.id != null) {
      if ((other.id == null) || !this.id.eq(other.id)) {
        return false
      }
    } else if (other.id != null) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountGroup}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      id: ((this.id != null) ? this.id.toString() : null),
      SortOrder: ((this.SortOrder != null) ? this.SortOrder : null),
      PlatformId: ((this.PlatformId != null) ? this.PlatformId.toString() : null),
      Name: ((this.Name != null) ? this.Name : null),
      Comment: ((this.Comment != null) ? this.Comment : null),
      Description: ((this.Description != null) ? this.Description : null),
      IsDemo: ((this.IsDemo != null) ? this.IsDemo : null),
      IsEnabled: ((this.IsEnabled != null) ? this.IsEnabled : null),
      IsOTPEnabled: ((this.IsOTPEnabled != null) ? this.IsOTPEnabled : null),
      IsTradeEnabled: ((this.IsTradeEnabled != null) ? this.IsTradeEnabled : null),
      DefaultAccountingType: ((this.DefaultAccountingType != null) ? this.DefaultAccountingType : null),
      DefaultBalanceCurrencyId: ((this.DefaultBalanceCurrencyId != null) ? this.DefaultBalanceCurrencyId.toString() : null),
      DefaultBalance: ((this.DefaultBalance != null) ? this.DefaultBalance : null),
      DefaultCredit: ((this.DefaultCredit != null) ? this.DefaultCredit : null),
      DefaultLeverage: ((this.DefaultLeverage != null) ? this.DefaultLeverage : null),
      MarginCallLevel: ((this.MarginCallLevel != null) ? this.MarginCallLevel : null),
      MarginCallAccessType: ((this.MarginCallAccessType != null) ? this.MarginCallAccessType : null),
      StopOutLevel: ((this.StopOutLevel != null) ? this.StopOutLevel : null),
      StopOutType: ((this.StopOutType != null) ? this.StopOutType : null),
      StopOutAccessType: ((this.StopOutAccessType != null) ? this.StopOutAccessType : null),
      DefaultMaxPendingOrders: ((this.DefaultMaxPendingOrders != null) ? this.DefaultMaxPendingOrders.toNumber() : null),
      SymbolGroupSettings: ((this.SymbolGroupSettings != null) ? fbe.MapToObject(new Map(Array.from(this.SymbolGroupSettings, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null),
      IsSwapEnabled: ((this.IsSwapEnabled != null) ? this.IsSwapEnabled : null),
      MinPasswordLength: ((this.MinPasswordLength != null) ? this.MinPasswordLength : null),
      Deprecated1: ((this.Deprecated1 != null) ? this.Deprecated1 : null),
      Deprecated2: ((this.Deprecated2 != null) ? this.Deprecated2 : null),
      IsSSLAccessEnabled: ((this.IsSSLAccessEnabled != null) ? this.IsSSLAccessEnabled : null),
      IsHTTPSAccessEnabled: ((this.IsHTTPSAccessEnabled != null) ? this.IsHTTPSAccessEnabled : null),
      IsWSSAccessEnabled: ((this.IsWSSAccessEnabled != null) ? this.IsWSSAccessEnabled : null),
      IsFIXAccessEnabled: ((this.IsFIXAccessEnabled != null) ? this.IsFIXAccessEnabled : null),
      Index: ((this.Index != null) ? this.Index : null),
      MaxLeverage: ((this.MaxLeverage != null) ? this.MaxLeverage : null),
      LeverageProfileId: ((this.LeverageProfileId != null) ? this.LeverageProfileId.toString() : null),
      DefaultMaxOrders: ((this.DefaultMaxOrders != null) ? this.DefaultMaxOrders.toNumber() : null),
      MaxDepositOperationAmount: ((this.MaxDepositOperationAmount != null) ? this.MaxDepositOperationAmount : null),
      BotApiEnabled: ((this.BotApiEnabled != null) ? this.BotApiEnabled : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountGroup.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountGroup} other Object value
   * @returns {!AccountGroup} Created struct
   */
  static fromObject (other) {
    return new AccountGroup().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountGroup}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountGroup.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountGroup}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 44
  }
}

export { AccountGroup };

/**
 * Fast Binary Encoding AccountGroup field model
 */
class FieldModelAccountGroup extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.id = new fbe.FieldModelUUID(buffer, 4 + 4)
    this.SortOrder = new fbe.FieldModelUInt32(buffer, this.id.fbeOffset + this.id.fbeSize)
    this.PlatformId = new fbe.FieldModelUUID(buffer, this.SortOrder.fbeOffset + this.SortOrder.fbeSize)
    this.Name = new fbe.FieldModelString(buffer, this.PlatformId.fbeOffset + this.PlatformId.fbeSize)
    this.Comment = new fbe.FieldModelString(buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.Description = new fbe.FieldModelString(buffer, this.Comment.fbeOffset + this.Comment.fbeSize)
    this.IsDemo = new fbe.FieldModelBool(buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.IsEnabled = new fbe.FieldModelBool(buffer, this.IsDemo.fbeOffset + this.IsDemo.fbeSize)
    this.IsOTPEnabled = new fbe.FieldModelBool(buffer, this.IsEnabled.fbeOffset + this.IsEnabled.fbeSize)
    this.IsTradeEnabled = new fbe.FieldModelBool(buffer, this.IsOTPEnabled.fbeOffset + this.IsOTPEnabled.fbeSize)
    this.DefaultAccountingType = new FieldModelAccountingType(buffer, this.IsTradeEnabled.fbeOffset + this.IsTradeEnabled.fbeSize)
    this.DefaultBalanceCurrencyId = new fbe.FieldModelUUID(buffer, this.DefaultAccountingType.fbeOffset + this.DefaultAccountingType.fbeSize)
    this.DefaultBalance = new fbe.FieldModelDouble(buffer, this.DefaultBalanceCurrencyId.fbeOffset + this.DefaultBalanceCurrencyId.fbeSize)
    this.DefaultCredit = new fbe.FieldModelDouble(buffer, this.DefaultBalance.fbeOffset + this.DefaultBalance.fbeSize)
    this.DefaultLeverage = new fbe.FieldModelUInt32(buffer, this.DefaultCredit.fbeOffset + this.DefaultCredit.fbeSize)
    this.MarginCallLevel = new fbe.FieldModelDouble(buffer, this.DefaultLeverage.fbeOffset + this.DefaultLeverage.fbeSize)
    this.MarginCallAccessType = new FieldModelTradingMode(buffer, this.MarginCallLevel.fbeOffset + this.MarginCallLevel.fbeSize)
    this.StopOutLevel = new fbe.FieldModelDouble(buffer, this.MarginCallAccessType.fbeOffset + this.MarginCallAccessType.fbeSize)
    this.StopOutType = new FieldModelStopOutType(buffer, this.StopOutLevel.fbeOffset + this.StopOutLevel.fbeSize)
    this.StopOutAccessType = new FieldModelTradingMode(buffer, this.StopOutType.fbeOffset + this.StopOutType.fbeSize)
    this.DefaultMaxPendingOrders = new fbe.FieldModelUInt64(buffer, this.StopOutAccessType.fbeOffset + this.StopOutAccessType.fbeSize)
    this.SymbolGroupSettings = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, this.DefaultMaxPendingOrders.fbeOffset + this.DefaultMaxPendingOrders.fbeSize), new FieldModelSymbolGroupSettings(buffer, this.DefaultMaxPendingOrders.fbeOffset + this.DefaultMaxPendingOrders.fbeSize), buffer, this.DefaultMaxPendingOrders.fbeOffset + this.DefaultMaxPendingOrders.fbeSize)
    this.IsSwapEnabled = new fbe.FieldModelBool(buffer, this.SymbolGroupSettings.fbeOffset + this.SymbolGroupSettings.fbeSize)
    this.MinPasswordLength = new fbe.FieldModelUInt8(buffer, this.IsSwapEnabled.fbeOffset + this.IsSwapEnabled.fbeSize)
    this.Deprecated1 = new fbe.FieldModelBool(buffer, this.MinPasswordLength.fbeOffset + this.MinPasswordLength.fbeSize)
    this.Deprecated2 = new fbe.FieldModelBool(buffer, this.Deprecated1.fbeOffset + this.Deprecated1.fbeSize)
    this.IsSSLAccessEnabled = new fbe.FieldModelBool(buffer, this.Deprecated2.fbeOffset + this.Deprecated2.fbeSize)
    this.IsHTTPSAccessEnabled = new fbe.FieldModelBool(buffer, this.IsSSLAccessEnabled.fbeOffset + this.IsSSLAccessEnabled.fbeSize)
    this.IsWSSAccessEnabled = new fbe.FieldModelBool(buffer, this.IsHTTPSAccessEnabled.fbeOffset + this.IsHTTPSAccessEnabled.fbeSize)
    this.IsFIXAccessEnabled = new fbe.FieldModelBool(buffer, this.IsWSSAccessEnabled.fbeOffset + this.IsWSSAccessEnabled.fbeSize)
    this.Index = new fbe.FieldModelUInt16(buffer, this.IsFIXAccessEnabled.fbeOffset + this.IsFIXAccessEnabled.fbeSize)
    this.MaxLeverage = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.Index.fbeOffset + this.Index.fbeSize), buffer, this.Index.fbeOffset + this.Index.fbeSize)
    this.LeverageProfileId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.MaxLeverage.fbeOffset + this.MaxLeverage.fbeSize), buffer, this.MaxLeverage.fbeOffset + this.MaxLeverage.fbeSize)
    this.DefaultMaxOrders = new fbe.FieldModelUInt64(buffer, this.LeverageProfileId.fbeOffset + this.LeverageProfileId.fbeSize)
    this.MaxDepositOperationAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.DefaultMaxOrders.fbeOffset + this.DefaultMaxOrders.fbeSize), buffer, this.DefaultMaxOrders.fbeOffset + this.DefaultMaxOrders.fbeSize)
    this.BotApiEnabled = new fbe.FieldModelBool(buffer, this.MaxDepositOperationAmount.fbeOffset + this.MaxDepositOperationAmount.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.id.fbeSize + this.SortOrder.fbeSize + this.PlatformId.fbeSize + this.Name.fbeSize + this.Comment.fbeSize + this.Description.fbeSize + this.IsDemo.fbeSize + this.IsEnabled.fbeSize + this.IsOTPEnabled.fbeSize + this.IsTradeEnabled.fbeSize + this.DefaultAccountingType.fbeSize + this.DefaultBalanceCurrencyId.fbeSize + this.DefaultBalance.fbeSize + this.DefaultCredit.fbeSize + this.DefaultLeverage.fbeSize + this.MarginCallLevel.fbeSize + this.MarginCallAccessType.fbeSize + this.StopOutLevel.fbeSize + this.StopOutType.fbeSize + this.StopOutAccessType.fbeSize + this.DefaultMaxPendingOrders.fbeSize + this.SymbolGroupSettings.fbeSize + this.IsSwapEnabled.fbeSize + this.MinPasswordLength.fbeSize + this.Deprecated1.fbeSize + this.Deprecated2.fbeSize + this.IsSSLAccessEnabled.fbeSize + this.IsHTTPSAccessEnabled.fbeSize + this.IsWSSAccessEnabled.fbeSize + this.IsFIXAccessEnabled.fbeSize + this.Index.fbeSize + this.MaxLeverage.fbeSize + this.LeverageProfileId.fbeSize + this.DefaultMaxOrders.fbeSize + this.MaxDepositOperationAmount.fbeSize + this.BotApiEnabled.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.id.fbeExtra + this.SortOrder.fbeExtra + this.PlatformId.fbeExtra + this.Name.fbeExtra + this.Comment.fbeExtra + this.Description.fbeExtra + this.IsDemo.fbeExtra + this.IsEnabled.fbeExtra + this.IsOTPEnabled.fbeExtra + this.IsTradeEnabled.fbeExtra + this.DefaultAccountingType.fbeExtra + this.DefaultBalanceCurrencyId.fbeExtra + this.DefaultBalance.fbeExtra + this.DefaultCredit.fbeExtra + this.DefaultLeverage.fbeExtra + this.MarginCallLevel.fbeExtra + this.MarginCallAccessType.fbeExtra + this.StopOutLevel.fbeExtra + this.StopOutType.fbeExtra + this.StopOutAccessType.fbeExtra + this.DefaultMaxPendingOrders.fbeExtra + this.SymbolGroupSettings.fbeExtra + this.IsSwapEnabled.fbeExtra + this.MinPasswordLength.fbeExtra + this.Deprecated1.fbeExtra + this.Deprecated2.fbeExtra + this.IsSSLAccessEnabled.fbeExtra + this.IsHTTPSAccessEnabled.fbeExtra + this.IsWSSAccessEnabled.fbeExtra + this.IsFIXAccessEnabled.fbeExtra + this.Index.fbeExtra + this.MaxLeverage.fbeExtra + this.LeverageProfileId.fbeExtra + this.DefaultMaxOrders.fbeExtra + this.MaxDepositOperationAmount.fbeExtra + this.BotApiEnabled.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountGroup.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 44
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountGroup}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountGroup}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.id.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.SortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PlatformId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Comment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsDemo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsDemo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsDemo.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.IsOTPEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsOTPEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsTradeEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.DefaultAccountingType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultAccountingType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultAccountingType.fbeSize

    if ((fbeCurrentSize + this.DefaultBalanceCurrencyId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultBalanceCurrencyId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultBalanceCurrencyId.fbeSize

    if ((fbeCurrentSize + this.DefaultBalance.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultBalance.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultBalance.fbeSize

    if ((fbeCurrentSize + this.DefaultCredit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultCredit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultCredit.fbeSize

    if ((fbeCurrentSize + this.DefaultLeverage.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultLeverage.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultLeverage.fbeSize

    if ((fbeCurrentSize + this.MarginCallLevel.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginCallLevel.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCallLevel.fbeSize

    if ((fbeCurrentSize + this.MarginCallAccessType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginCallAccessType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCallAccessType.fbeSize

    if ((fbeCurrentSize + this.StopOutLevel.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopOutLevel.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutLevel.fbeSize

    if ((fbeCurrentSize + this.StopOutType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopOutType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutType.fbeSize

    if ((fbeCurrentSize + this.StopOutAccessType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopOutAccessType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutAccessType.fbeSize

    if ((fbeCurrentSize + this.DefaultMaxPendingOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultMaxPendingOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultMaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupSettings.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolGroupSettings.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupSettings.fbeSize

    if ((fbeCurrentSize + this.IsSwapEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsSwapEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsSwapEnabled.fbeSize

    if ((fbeCurrentSize + this.MinPasswordLength.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MinPasswordLength.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MinPasswordLength.fbeSize

    if ((fbeCurrentSize + this.Deprecated1.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deprecated1.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated1.fbeSize

    if ((fbeCurrentSize + this.Deprecated2.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deprecated2.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated2.fbeSize

    if ((fbeCurrentSize + this.IsSSLAccessEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsSSLAccessEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsSSLAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsHTTPSAccessEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsHTTPSAccessEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsHTTPSAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsWSSAccessEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsWSSAccessEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsWSSAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsFIXAccessEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsFIXAccessEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsFIXAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.Index.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Index.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Index.fbeSize

    if ((fbeCurrentSize + this.MaxLeverage.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxLeverage.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxLeverage.fbeSize

    if ((fbeCurrentSize + this.LeverageProfileId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LeverageProfileId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LeverageProfileId.fbeSize

    if ((fbeCurrentSize + this.DefaultMaxOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultMaxOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultMaxOrders.fbeSize

    if ((fbeCurrentSize + this.MaxDepositOperationAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxDepositOperationAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxDepositOperationAmount.fbeSize

    if ((fbeCurrentSize + this.BotApiEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BotApiEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BotApiEnabled.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountGroup}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountGroup}
   * @param {!AccountGroup} fbeValue Default value, defaults is new AccountGroup()
   * @returns {!AccountGroup} AccountGroup value
   */
  get (fbeValue = new AccountGroup()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountGroup}
   * @param {!AccountGroup} fbeValue AccountGroup value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) <= fbeStructSize) {
      fbeValue.id = this.id.get(UUID.sequential())
    } else {
      fbeValue.id = UUID.sequential()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.SortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.SortOrder = this.SortOrder.get()
    } else {
      fbeValue.SortOrder = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) <= fbeStructSize) {
      fbeValue.PlatformId = this.PlatformId.get()
    } else {
      fbeValue.PlatformId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) <= fbeStructSize) {
      fbeValue.Comment = this.Comment.get()
    } else {
      fbeValue.Comment = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsDemo.fbeSize) <= fbeStructSize) {
      fbeValue.IsDemo = this.IsDemo.get()
    } else {
      fbeValue.IsDemo = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsDemo.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsEnabled = this.IsEnabled.get()
    } else {
      fbeValue.IsEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.IsOTPEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsOTPEnabled = this.IsOTPEnabled.get()
    } else {
      fbeValue.IsOTPEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsTradeEnabled = this.IsTradeEnabled.get()
    } else {
      fbeValue.IsTradeEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.DefaultAccountingType.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultAccountingType = this.DefaultAccountingType.get()
    } else {
      fbeValue.DefaultAccountingType = new AccountingType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultAccountingType.fbeSize

    if ((fbeCurrentSize + this.DefaultBalanceCurrencyId.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultBalanceCurrencyId = this.DefaultBalanceCurrencyId.get()
    } else {
      fbeValue.DefaultBalanceCurrencyId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultBalanceCurrencyId.fbeSize

    if ((fbeCurrentSize + this.DefaultBalance.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultBalance = this.DefaultBalance.get()
    } else {
      fbeValue.DefaultBalance = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultBalance.fbeSize

    if ((fbeCurrentSize + this.DefaultCredit.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultCredit = this.DefaultCredit.get()
    } else {
      fbeValue.DefaultCredit = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultCredit.fbeSize

    if ((fbeCurrentSize + this.DefaultLeverage.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultLeverage = this.DefaultLeverage.get()
    } else {
      fbeValue.DefaultLeverage = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultLeverage.fbeSize

    if ((fbeCurrentSize + this.MarginCallLevel.fbeSize) <= fbeStructSize) {
      fbeValue.MarginCallLevel = this.MarginCallLevel.get()
    } else {
      fbeValue.MarginCallLevel = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCallLevel.fbeSize

    if ((fbeCurrentSize + this.MarginCallAccessType.fbeSize) <= fbeStructSize) {
      fbeValue.MarginCallAccessType = this.MarginCallAccessType.get()
    } else {
      fbeValue.MarginCallAccessType = new TradingMode()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCallAccessType.fbeSize

    if ((fbeCurrentSize + this.StopOutLevel.fbeSize) <= fbeStructSize) {
      fbeValue.StopOutLevel = this.StopOutLevel.get()
    } else {
      fbeValue.StopOutLevel = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutLevel.fbeSize

    if ((fbeCurrentSize + this.StopOutType.fbeSize) <= fbeStructSize) {
      fbeValue.StopOutType = this.StopOutType.get()
    } else {
      fbeValue.StopOutType = new StopOutType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutType.fbeSize

    if ((fbeCurrentSize + this.StopOutAccessType.fbeSize) <= fbeStructSize) {
      fbeValue.StopOutAccessType = this.StopOutAccessType.get()
    } else {
      fbeValue.StopOutAccessType = new TradingMode()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopOutAccessType.fbeSize

    if ((fbeCurrentSize + this.DefaultMaxPendingOrders.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultMaxPendingOrders = this.DefaultMaxPendingOrders.get()
    } else {
      fbeValue.DefaultMaxPendingOrders = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultMaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupSettings.fbeSize) <= fbeStructSize) {
      this.SymbolGroupSettings.get(fbeValue.SymbolGroupSettings)
    } else {
      fbeValue.SymbolGroupSettings.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupSettings.fbeSize

    if ((fbeCurrentSize + this.IsSwapEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsSwapEnabled = this.IsSwapEnabled.get()
    } else {
      fbeValue.IsSwapEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsSwapEnabled.fbeSize

    if ((fbeCurrentSize + this.MinPasswordLength.fbeSize) <= fbeStructSize) {
      fbeValue.MinPasswordLength = this.MinPasswordLength.get()
    } else {
      fbeValue.MinPasswordLength = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MinPasswordLength.fbeSize

    if ((fbeCurrentSize + this.Deprecated1.fbeSize) <= fbeStructSize) {
      fbeValue.Deprecated1 = this.Deprecated1.get()
    } else {
      fbeValue.Deprecated1 = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated1.fbeSize

    if ((fbeCurrentSize + this.Deprecated2.fbeSize) <= fbeStructSize) {
      fbeValue.Deprecated2 = this.Deprecated2.get()
    } else {
      fbeValue.Deprecated2 = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated2.fbeSize

    if ((fbeCurrentSize + this.IsSSLAccessEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsSSLAccessEnabled = this.IsSSLAccessEnabled.get(true)
    } else {
      fbeValue.IsSSLAccessEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsSSLAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsHTTPSAccessEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsHTTPSAccessEnabled = this.IsHTTPSAccessEnabled.get(true)
    } else {
      fbeValue.IsHTTPSAccessEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsHTTPSAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsWSSAccessEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsWSSAccessEnabled = this.IsWSSAccessEnabled.get(true)
    } else {
      fbeValue.IsWSSAccessEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsWSSAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.IsFIXAccessEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsFIXAccessEnabled = this.IsFIXAccessEnabled.get(true)
    } else {
      fbeValue.IsFIXAccessEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsFIXAccessEnabled.fbeSize

    if ((fbeCurrentSize + this.Index.fbeSize) <= fbeStructSize) {
      fbeValue.Index = this.Index.get()
    } else {
      fbeValue.Index = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Index.fbeSize

    if ((fbeCurrentSize + this.MaxLeverage.fbeSize) <= fbeStructSize) {
      fbeValue.MaxLeverage = this.MaxLeverage.get()
    } else {
      fbeValue.MaxLeverage = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxLeverage.fbeSize

    if ((fbeCurrentSize + this.LeverageProfileId.fbeSize) <= fbeStructSize) {
      fbeValue.LeverageProfileId = this.LeverageProfileId.get()
    } else {
      fbeValue.LeverageProfileId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LeverageProfileId.fbeSize

    if ((fbeCurrentSize + this.DefaultMaxOrders.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultMaxOrders = this.DefaultMaxOrders.get(new UInt64(2000, 0))
    } else {
      fbeValue.DefaultMaxOrders = new UInt64(2000, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultMaxOrders.fbeSize

    if ((fbeCurrentSize + this.MaxDepositOperationAmount.fbeSize) <= fbeStructSize) {
      fbeValue.MaxDepositOperationAmount = this.MaxDepositOperationAmount.get()
    } else {
      fbeValue.MaxDepositOperationAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxDepositOperationAmount.fbeSize

    if ((fbeCurrentSize + this.BotApiEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.BotApiEnabled = this.BotApiEnabled.get(true)
    } else {
      fbeValue.BotApiEnabled = true
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BotApiEnabled.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountGroup}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountGroup}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountGroup}
   * @param {!AccountGroup} fbeValue AccountGroup value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountGroup}
   * @param {AccountGroup} fbeValue AccountGroup value
   */
  setFields (fbeValue) {
    this.id.set(fbeValue.id)
    this.SortOrder.set(fbeValue.SortOrder)
    this.PlatformId.set(fbeValue.PlatformId)
    this.Name.set(fbeValue.Name)
    this.Comment.set(fbeValue.Comment)
    this.Description.set(fbeValue.Description)
    this.IsDemo.set(fbeValue.IsDemo)
    this.IsEnabled.set(fbeValue.IsEnabled)
    this.IsOTPEnabled.set(fbeValue.IsOTPEnabled)
    this.IsTradeEnabled.set(fbeValue.IsTradeEnabled)
    this.DefaultAccountingType.set(fbeValue.DefaultAccountingType)
    this.DefaultBalanceCurrencyId.set(fbeValue.DefaultBalanceCurrencyId)
    this.DefaultBalance.set(fbeValue.DefaultBalance)
    this.DefaultCredit.set(fbeValue.DefaultCredit)
    this.DefaultLeverage.set(fbeValue.DefaultLeverage)
    this.MarginCallLevel.set(fbeValue.MarginCallLevel)
    this.MarginCallAccessType.set(fbeValue.MarginCallAccessType)
    this.StopOutLevel.set(fbeValue.StopOutLevel)
    this.StopOutType.set(fbeValue.StopOutType)
    this.StopOutAccessType.set(fbeValue.StopOutAccessType)
    this.DefaultMaxPendingOrders.set(fbeValue.DefaultMaxPendingOrders)
    this.SymbolGroupSettings.set(fbeValue.SymbolGroupSettings)
    this.IsSwapEnabled.set(fbeValue.IsSwapEnabled)
    this.MinPasswordLength.set(fbeValue.MinPasswordLength)
    this.Deprecated1.set(fbeValue.Deprecated1)
    this.Deprecated2.set(fbeValue.Deprecated2)
    this.IsSSLAccessEnabled.set(fbeValue.IsSSLAccessEnabled)
    this.IsHTTPSAccessEnabled.set(fbeValue.IsHTTPSAccessEnabled)
    this.IsWSSAccessEnabled.set(fbeValue.IsWSSAccessEnabled)
    this.IsFIXAccessEnabled.set(fbeValue.IsFIXAccessEnabled)
    this.Index.set(fbeValue.Index)
    this.MaxLeverage.set(fbeValue.MaxLeverage)
    this.LeverageProfileId.set(fbeValue.LeverageProfileId)
    this.DefaultMaxOrders.set(fbeValue.DefaultMaxOrders)
    this.MaxDepositOperationAmount.set(fbeValue.MaxDepositOperationAmount)
    this.BotApiEnabled.set(fbeValue.BotApiEnabled)
  }
}

export { FieldModelAccountGroup };

/**
 * Fast Binary Encoding AccountGroup model
 */
class AccountGroupModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountGroup(this.buffer, 4)
  }

  /**
   * Get the AccountGroup model
   * @this {!AccountGroupModel}
   * @returns {!FieldModelAccountGroup} model AccountGroup model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountGroupModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountGroupModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountGroupModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountGroupModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountGroup.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountGroupModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountGroupModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountGroupModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountGroupModel}
   * @param {!AccountGroup} value AccountGroup value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountGroupModel}
   * @param {!AccountGroup} value AccountGroup value, defaults is new AccountGroup()
   * @return {!object} Deserialized AccountGroup value and its size
   */
  deserialize (value = new AccountGroup()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountGroup(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountGroup(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountGroupModel}
   * @param {!number} prev Previous AccountGroup model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountGroupModel };
